module.exports = __webpack_public_path__ + "static/media/Chandelure_gaussian2.401d3b7f.png";